import { DetailsCard } from '../CoverageSummary';
import type { composeGlobalDeltas } from '../helpers/coverage-summary.utils';
import { GlobalHeader } from './CoverageSummaryGlobals/GlobalHeader';
import { Global } from './CoverageSummaryGlobals/Global';

interface CoverageSummaryGlobalsProps {
  handleShowAllDetails: () => void;
  mergedGlobals: ReturnType<typeof composeGlobalDeltas>;
  showAllDetails: boolean;
}

export const CoverageSummaryGlobals = ({
  handleShowAllDetails,
  mergedGlobals,
  showAllDetails,
}: CoverageSummaryGlobalsProps) => {
  return (
    <DetailsCard>
      <GlobalHeader
        handleShowAllDetails={handleShowAllDetails}
        showAllDetails={showAllDetails}
      />

      <Global mergedGlobals={mergedGlobals} showAllDetails={showAllDetails} />
    </DetailsCard>
  );
};
